import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Move the RoutePlan to a specific revision.
 *
 * @private
 */
export const goToTransactionRevision = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  number,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/transaction/goto', async (toRevision, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/transaction/goto', {
      category: 'rpc',
      type: 'rpc/transaction/goto',
      toRevision,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {goToTransactionRevision}`,
      { tags: ['rpc', 'transaction'], info: { revision: toRevision } },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Go to revision ${toRevision} Failed`,
      error,
    })
  }
})
